import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import Transition from './Dialogs/Transition';

const styles = {
	role: {
		marginBottom: 25,
	},
	roleName: {
		fontWeight: 600,
	},
	sectionLabel: {
		fontWeight: 600,
		fontSize: 13,
		color: '#777',
		textTransform: 'uppercase',
		letterSpacing: 1,
		marginTop: 8,
	},
	list: {
		margin: '5px 0 0 0',
		paddingLeft: 20,
	},
};

//- Keep this in sync with the allowRoles arrays on the backend API definitions
//- (grep allowRoles in fmp.pearsonfuels.com/libs) and the LeftDrawer menu allowRoles.
const roleAccess = [
	{
		role: 'Pearson Employee',
		summary: 'Everything + Permissions limit',
	},
	{
		role: 'External Logistics',
		pages: [
			'Dashboard',
			'Stations',
			'Logistics: Monitoring, Inventory, Station Deliveries, Delivery Search, Activity Log',
		],
		abilities: [
			'Full station delivery management: create, activate, update, estimate, cancel / uncancel, and verify deliveries',
			'Search deliveries and the delivery activity log',
			'Look up carriers, terminals, and fuel vendors / suppliers',
			'Loading numbers: import, view, search, and stats',
			'Master delivery search',
			'Add, update, and view station sales, inventory, and delivery records',
			'Daily tank sales and tank inventory reports',
			'Capture and convert delivery documents (BOL scans)',
			'View stations, monitoring data, and accounting data dumps',
		],
	},
	{
		role: 'External Reporting',
		pages: [
			'Dashboard',
			'Stations',
			'Reports: Total Sales, Station Sales, New Station Board, Sales Export, Fuel Forecast, OPIS Pricing',
		],
		abilities: [
			'Sales reports: projected / up-to-date / current monthly, prior week, prior Mon–Fri, prior 3-day',
			'Tank sales reports (monthly and daily) and daily tank inventory report',
			'Fuel forecast download and rebate-program station list',
			'Search station sales records; add, update, and view inventory and delivery records',
			'Search station deliveries and the delivery log (read-only)',
			'View stations, monitoring data, accounting data dumps, and data records (incl. DGS rate)',
		],
	},
	{
		role: 'MHX API Access',
		pages: ['None — API-only integration account, no FMP pages'],
		abilities: [
			'Submit MHX BOLs and BOL PDFs',
			'Fetch MHX loading numbers',
			'Submit USDG BOLs',
		],
	},
	{
		role: 'Superior API Access',
		pages: ['None — API-only integration account, no FMP pages'],
		abilities: [
			'Submit Superior Tank Lines invoices electronically (superior.invoice.post)',
			'Submit Superior delivery tickets with the scanned paperwork PDF (superior.deliveryTicket.post)',
		],
	},
];

export default class RoleAccessDialog extends Component {
	render() {
		const { open, onClose } = this.props;

		return (
			<Dialog open={open} TransitionComponent={Transition} onClose={onClose} maxWidth="md">
				<div style={{ padding: '20px 40px' }}>
					<DialogTitle>Role Access</DialogTitle>
					<DialogContent>
						{roleAccess.map(({ role, summary, pages, abilities }) => {
							return (
								<div key={role} style={styles.role}>
									<Typography variant="h6" style={styles.roleName}>
										{role}
									</Typography>
									{summary && <Typography variant="body2">{summary}</Typography>}
									{pages && (
										<div>
											<div style={styles.sectionLabel}>Pages</div>
											<ul style={styles.list}>
												{pages.map((page) => {
													return (
														<li key={page}>
															<Typography variant="body2">{page}</Typography>
														</li>
													);
												})}
											</ul>
										</div>
									)}
									{abilities && (
										<div>
											<div style={styles.sectionLabel}>Can Do</div>
											<ul style={styles.list}>
												{abilities.map((ability) => {
													return (
														<li key={ability}>
															<Typography variant="body2">{ability}</Typography>
														</li>
													);
												})}
											</ul>
										</div>
									)}
								</div>
							);
						})}
					</DialogContent>
					<DialogActions>
						<Button onClick={onClose}>Close</Button>
					</DialogActions>
				</div>
			</Dialog>
		);
	}
}

RoleAccessDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
};
